import Form from 'components/Form';
import { IPatientInfo } from 'apis/admin/type';

import RowContainer from './RowContainer';
import RowContentBord from './RowContentBord';

interface Props {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
}

const CommonPatientInfo = (props: Props) => {
  const {
    patientInfo: {
      patient_id,
      name,
      age,
      gender,
      ward,
      room,
      admin_hod,
      admin_pod,
      department,
      disease_main,
      main_doctor,
    },
    nurseName,
  } = props;

  const infos = [
    { title: 'Tên bệnh nhân', value: name },
    { title: 'Mã số đăng ký', value: patient_id },
    { title: 'Tuổi', value: age },
    { title: 'Giới tính', value: gender },
    { title: 'Khu vực', value: ward },
    { title: 'Phòng', value: room },
    { title: 'HOD', value: admin_hod },
    { title: 'POD', value: admin_pod },
    { title: 'Khoa điều trị', value: department },
    { title: 'Chẩn đoán', value: disease_main.disease_eng },
    { title: 'Bác sĩ phụ trách', value: main_doctor },
    { title: 'Y tá phụ trách', value: nurseName },
  ];

  return (
    <RowContainer xs={12}>
      {infos.map(({ title, value }) =>
        title === 'Giới tính' ? (
          <RowContentBord title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiRadioGroup
              i18nKey="GENDER"
              values={[1, 2]}
              value={Number(value)}
              defaultValue={Number(value)}
            />
          </RowContentBord>
        ) : (
          <RowContentBord title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiTextField value={value} InputProps={{ readOnly: true }} />
          </RowContentBord>
        )
      )}
    </RowContainer>
  );
};

export default CommonPatientInfo;
